import React, { useCallback, useEffect, useRef } from "react";
import PropTypes from "prop-types";
//Simple bar
import SimpleBar from "simplebar-react";
// MetisMenu:群組開合(UAT 8/27 客戶要求「跟原本選單方式一樣」→ 恢復模板的收合行為)
import MetisMenu from "metismenujs";
import { useLocation } from "react-router-dom";
import { Link } from "react-router-dom";
import { useUiStore } from "../../stores/uiStore";
import { MODULE_ICON } from "../../helpers/moduleIcons";
import { useAdminMenu } from "../../query/useAdminMenu";
import { hasRoute } from "../../routes/allRoutes";
import { useRbac } from "../../components/DCKeeper";


/**
 * 交付範圍外的入口先隱藏。可見性有兩道關卡,兩道都過才畫:
 *   1. 後端 `AdminMenu/GetMenu` 給不給這個模組(ADR-0003);
 *   2. `helpers/releaseScope` 的交付範圍表說有沒有對客戶開放。
 *
 * 第 2 道是 2026-09-15 補的:在那之前側欄只看第 1 道、`allRoutes` 只看第 2 道,
 * 於是側欄畫得出「營運資訊／監控派工／審核中心」,點進去卻是「找不到這個頁面」(票 36)。
 * **兩邊都吃 releaseScope 那張表**,不要再各判各的。
 */

const SidebarContent = (props) => {
    const ref = useRef();
    const location = useLocation();
    const approvalPending = useUiStore((s) => s.approvalPending); // 審核待辦徽章

    // 主模組可見性由後端 GetMenu 決定(ADR-0003)。
    // **降級往保守倒**(票 route-guard/01 B1):`systems` 還沒回來(載入中/失敗)時
    // 原本是「全部顯示」—— 等於權限系統掛掉的時候側欄是全開的。改成先不顯示,
    // 失敗時另外講一句話,免得看起來像壞掉。
    // 與交付範圍表(helpers/releaseScope)並存 —— 兩個條件都過才顯示。
    // **一定要跟 allRoutes 吃同一張表**:9/8~9/15 那次就是側欄不吃、路由吃,
    // 結果側欄點得到、點進去 404(票 36)。
    const { systems, isLoading: menuLoading, error: menuError } = useAdminMenu();
    const show = (systemName) => !!systems && systems.has(systemName);
    // **畫不畫,直接問路由表**(票 36 review):路由被拿掉的原因不只一種 ——
    // 交付範圍表(releaseScope)擋一種、devOnly(空殼頁)擋另一種。只看其中一張表,
    // 另一種就會漏掉,於是又變成「側欄畫得出、點進去 404」。問路由表就沒有漏網的可能。
    const anyRoute = (...paths) => paths.some(hasRoute);
    // 審核中心是 ADR-0003 的文件化例外:8/11 真後端 GetMenu 實回**沒有**審核節點
    // (角色矩陣裡「審核功能」是功能不是模組),入口可見性改走 RBAC
    // (Viewer 隱藏,其餘角色可見);GetMenu 若日後補節點,再改回 show()。
    const { can } = useRbac();
    const showApproval = !!systems && can("approval.read") && hasRoute("/dck/approvals");

    // 群組標題本身不導頁,點擊只做開合(UAT 8/27:恢復模板 MetisMenu 行為 ——
    // 只有點擊到的群組展開,再點收合;預設 accordion,開一個收其他)。
    // 沿用模板的 <a href="/#">(metismenu 綁 a 元素;"/#" 過 a11y 規則),
    // preventDefault 擋掉實際導頁,開合交給 MetisMenu。
    const stopNav = (e) => e.preventDefault();

    const activateParentDropdown = useCallback((item) => {
        item.classList.add("active");
        const parent = item.parentElement;
        const parent2El = parent.childNodes[1];

        if (parent2El && parent2El.id !== "side-menu") {
            parent2El.classList.add("mm-show");
        }

        if (parent) {
            parent.classList.add("mm-active");
            const parent2 = parent.parentElement;

            if (parent2) {
                parent2.classList.add("mm-show"); // ul tag

                const parent3 = parent2.parentElement; // li tag

                if (parent3) {
                    parent3.classList.add("mm-active"); // li
                    parent3.childNodes[0].classList.add("mm-active"); //a
                    const parent4 = parent3.parentElement; // ul
                    if (parent4) {
                        parent4.classList.add("mm-show"); // ul
                        const parent5 = parent4.parentElement;
                        if (parent5) {
                            parent5.classList.add("mm-show"); // li
                            parent5.childNodes[0].classList.add("mm-active"); // a tag
                        }
                    }
                }
            }
            scrollElement(item);
            return false;
        }
        scrollElement(item);
        return false;
    }, []);

    const removeActivation = (items) => {
        for (var i = 0; i < items.length; ++i) {
            var item = items[i];
            const parent = items[i].parentElement;

            if (item && item.classList.contains("active")) {
                item.classList.remove("active");
            }
            if (parent) {
                const parent2El =
                    parent.childNodes && parent.childNodes.lenght && parent.childNodes[1]
                        ? parent.childNodes[1]
                        : null;
                if (parent2El && parent2El.id !== "side-menu") {
                    parent2El.classList.remove("mm-show");
                }

                parent.classList.remove("mm-active");
                const parent2 = parent.parentElement;

                if (parent2) {
                    parent2.classList.remove("mm-show");

                    const parent3 = parent2.parentElement;
                    if (parent3) {
                        parent3.classList.remove("mm-active"); // li
                        parent3.childNodes[0].classList.remove("mm-active");

                        const parent4 = parent3.parentElement; // ul
                        if (parent4) {
                            parent4.classList.remove("mm-show"); // ul
                            const parent5 = parent4.parentElement;
                            if (parent5) {
                                parent5.classList.remove("mm-show"); // li
                                parent5.childNodes[0].classList.remove("mm-active"); // a tag
                            }
                        }
                    }
                }
            }
        }
    };

    const activeMenu = useCallback(() => {
        const pathName = location.pathname;
        const search = location.search || "";
        let matchingMenuItem = null;
        const ul = document.getElementById("side-menu");
        // 群組標題(.menu-parent)不是可導航連結,排除以免 href="#" 誤判為命中目前路由
        const items = Array.from(ul.getElementsByTagName("a")).filter(
            (a) => !a.classList.contains("menu-parent")
        );
        removeActivation(items);

        // 優先比對 pathname + search(審核待辦/歷程),再退回 pathname
        for (let i = 0; i < items.length; ++i) {
            const item = items[i];
            if (item.pathname === pathName && item.search === search) {
                matchingMenuItem = item;
                break;
            }
        }
        if (!matchingMenuItem) {
            for (let i = 0; i < items.length; ++i) {
                if (pathName === items[i].pathname) {
                    matchingMenuItem = items[i];
                    break;
                }
            }
        }
        if (matchingMenuItem) {
            activateParentDropdown(matchingMenuItem);
        }
    }, [location.pathname, location.search, activateParentDropdown]);

    useEffect(() => {
        ref.current.recalculate();
    }, []);

    useEffect(() => {
        activeMenu();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        activeMenu();
    }, [activeMenu]);

    // GetMenu 回來後項目增減 → 重掛 MetisMenu(開合)並重算 active 標記。
    // MetisMenu 是掛在既有 DOM 上的行為層,項目增減後要 dispose 重建,
    // 否則新出現的群組沒有開合行為。
    //
    // ⚠️ dep 不能直接用 `systems`:useAdminMenu 每次 render 都回新的 Set,
    // 直接依賴會**每次 render 都 dispose/重掛** —— 開合動畫進行中被重掛,
    // metismenujs 的 init 會把過渡中的 sub-menu 蓋成 display:none,
    // transitionend 永遠不觸發,`mm-collapsing` 卡死之後整個群組再也點不開。
    // 改用集合內容序列化成字串,只有選單**內容**變動才重掛。
    const systemsKey = systems ? [...systems].sort().join(",") : "";
    useEffect(() => {
        // 防禦:上一輪若在動畫中被中斷,殘留的 mm-collapsing 會擋住 show/hide
        document.querySelectorAll("#side-menu .mm-collapsing")
            .forEach((el) => el.classList.remove("mm-collapsing"));
        const menu = new MetisMenu("#side-menu");
        activeMenu();
        return () => menu.dispose();
        // activeMenu 隨路由變 identity;路由變化的 active 標記交給上面的 effect,
        // 這裡只在選單內容變動時重掛,避免導頁也觸發 dispose/重建
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [systemsKey]);

    function scrollElement(item) {
        if (item) {
            const currentPosition = item.offsetTop;
            if (currentPosition > window.innerHeight) {
                ref.current.getScrollElement().scrollTop = currentPosition - 300;
            }
        }
    }
    return (
        <React.Fragment>
            <SimpleBar className="sidebar-menu-scroll" ref={ref}>
                <div id="sidebar-menu">

                    {/*
                      * 版面/圖示對齊 Figma 元件頁 side menu(15:848):
                      * 一層 boxicons 24px + 16px 字、二層 14px 字縮排 39px、列距 10px。
                      * 圖示取自 helpers/moduleIcons(與通知圖示同一份,設計稿要求兩邊一致)。
                      * UAT 8/27:客戶要求選單可開合、只有點到的群組展開(跟模板一樣)
                      * → 恢復 MetisMenu;群組標題仍不導頁,點擊只做開合。
                      */}
                    <ul className="metismenu list-unstyled" id="side-menu">
                        <li className="menu-title" data-key="t-menu">主選單</li>

                        {/* 選單還沒回來就先不列模組(B1 保守降級)。
                            這兩行是為了讓「空側欄」講得出原因,不是靜靜空著。 */}
                        {menuLoading ? (
                            <li className="menu-title text-muted">選單載入中…</li>
                        ) : null}
                        {!menuLoading && menuError ? (
                            <li className="menu-title text-warning">選單載入失敗，請重新整理</li>
                        ) : null}

                        {show("Dashboard") && (
                        <li>
                            <Link to="/dashboard">
                                <i className={`nav-icon bx ${MODULE_ICON.智慧看板}`}></i>
                                <span className="menu-item" data-key="t-dashboard">智慧看板</span>
                            </Link>
                        </li>
                        )}

                        {show("People") && (
                        <li>
                            <a href="/#" className="menu-parent has-arrow" onClick={stopNav}>
                                <i className={`nav-icon bx ${MODULE_ICON.人員管理}`}></i>
                                <span className="menu-item" data-key="t-accounts">人員管理</span>
                            </a>
                            <ul className="sub-menu">
                                {hasRoute("/dck/accounts/perms") ? <li><Link to="/dck/accounts/perms" data-key="t-perms">權限設定</Link></li> : null}
                                {hasRoute("/dck/accounts/users") ? <li><Link to="/dck/accounts/users" data-key="t-users">使用者資訊</Link></li> : null}
                                {hasRoute("/dck/accounts/work") ? <li><Link to="/dck/accounts/work" data-key="t-work">工作管理</Link></li> : null}
                            </ul>
                        </li>
                        )}

                        {show("Room") && (
                        <li>
                            <Link to="/dck/rooms">
                                <i className={`nav-icon bx ${MODULE_ICON.機房管理}`}></i>
                                <span className="menu-item" data-key="t-rooms">機房管理</span>
                            </Link>
                        </li>
                        )}

                        {show("Registry") && anyRoute("/dck/registry/ips", "/dck/registry/projects", "/dck/registry/contracts", "/dck/registry/vendors") ? (
                        <li>
                            <a href="/#" className="menu-parent has-arrow" onClick={stopNav}>
                                <i className={`nav-icon bx ${MODULE_ICON.營運資訊}`}></i>
                                <span className="menu-item" data-key="t-registry">營運資訊</span>
                            </a>
                            <ul className="sub-menu">
                                {hasRoute("/dck/registry/ips") ? <li><Link to="/dck/registry/ips" data-key="t-ips">IP資訊</Link></li> : null}
                                {hasRoute("/dck/registry/projects") ? <li><Link to="/dck/registry/projects" data-key="t-projects">專案資訊</Link></li> : null}
                                {hasRoute("/dck/registry/contracts") ? <li><Link to="/dck/registry/contracts" data-key="t-contracts">合約資訊</Link></li> : null}
                                {hasRoute("/dck/registry/vendors") ? <li><Link to="/dck/registry/vendors" data-key="t-vendors">廠商資訊</Link></li> : null}
                            </ul>
                        </li>
                        ) : null}

                        {show("Asset") && (
                        <li>
                            <a href="/#" className="menu-parent has-arrow" onClick={stopNav}>
                                <i className={`nav-icon bx ${MODULE_ICON.資產管理}`}></i>
                                <span className="menu-item" data-key="t-assets">資產管理</span>
                            </a>
                            <ul className="sub-menu">
                                {hasRoute("/dck/assets/cabinets") ? <li><Link to="/dck/assets/cabinets" data-key="t-cabinets">機櫃資訊</Link></li> : null}
                                {hasRoute("/dck/assets/hardware") ? <li><Link to="/dck/assets/hardware" data-key="t-hardware">硬體資訊</Link></li> : null}
                                {hasRoute("/dck/assets/software") ? <li><Link to="/dck/assets/software" data-key="t-software">軟體資訊</Link></li> : null}
                            </ul>
                        </li>
                        )}

                        {show("Monitor") && anyRoute("/dck/monitor/watch", "/dck/monitor/dispatch") ? (
                        <li>
                            <a href="/#" className="menu-parent has-arrow" onClick={stopNav}>
                                <i className={`nav-icon bx ${MODULE_ICON.監控派工}`}></i>
                                <span className="menu-item" data-key="t-monitor">監控派工</span>
                            </a>
                            <ul className="sub-menu">
                                {hasRoute("/dck/monitor/watch") ? <li><Link to="/dck/monitor/watch" data-key="t-watch">監控</Link></li> : null}
                                {hasRoute("/dck/monitor/dispatch") ? <li><Link to="/dck/monitor/dispatch" data-key="t-dispatch">派工</Link></li> : null}
                            </ul>
                        </li>
                        ) : null}

                        {show("Notify") && (
                        <li>
                            <a href="/#" className="menu-parent has-arrow" onClick={stopNav}>
                                <i className={`nav-icon bx ${MODULE_ICON.訊息功能}`}></i>
                                <span className="menu-item" data-key="t-notify">訊息功能</span>
                            </a>
                            {/* WF_v3:設定在查詢上面(各類訊息設定/訊息查詢) */}
                            <ul className="sub-menu">
                                {hasRoute("/dck/notify/settings") ? <li><Link to="/dck/notify/settings" data-key="t-notify-settings">各類訊息設定</Link></li> : null}
                                {hasRoute("/dck/notify") ? <li><Link to="/dck/notify" data-key="t-notify-query">訊息查詢</Link></li> : null}
                            </ul>
                        </li>
                        )}

                        {show("Report") && anyRoute("/dck/reports") ? (
                        <li>
                            <Link to="/dck/reports">
                                <i className={`nav-icon bx ${MODULE_ICON.報表功能}`}></i>
                                <span className="menu-item" data-key="t-reports">報表功能</span>
                            </Link>
                        </li>
                        ) : null}

                        {show("Decision") && anyRoute("/dck/analysis/alerts", "/dck/analysis/finance") ? (
                        <li>
                            <a href="/#" className="menu-parent has-arrow" onClick={stopNav}>
                                <i className={`nav-icon bx ${MODULE_ICON.決策分析}`}></i>
                                <span className="menu-item" data-key="t-analysis">決策分析</span>
                            </a>
                            <ul className="sub-menu">
                                {hasRoute("/dck/analysis/alerts") ? <li><Link to="/dck/analysis/alerts" data-key="t-alerts">告警預測</Link></li> : null}
                                {hasRoute("/dck/analysis/finance") ? <li><Link to="/dck/analysis/finance" data-key="t-finance">財務預測</Link></li> : null}
                            </ul>
                        </li>
                        ) : null}

                        {showApproval ? (
                        <li>
                            <a href="/#" className="menu-parent has-arrow" onClick={stopNav}>
                                <i className={`nav-icon bx ${MODULE_ICON.審核中心}`}></i>
                                <span className="menu-item" data-key="t-approvals">審核中心</span>
                                {approvalPending > 0 ? (
                                    <span className="badge rounded-pill bg-danger">{approvalPending}</span>
                                ) : null}
                            </a>
                            <ul className="sub-menu">
                                <li hidden={!hasRoute("/dck/approvals")}>
                                    <Link to="/dck/approvals?status=pending" data-key="t-approvals-pending">
                                        審核待辦
                                        {approvalPending > 0 ? (
                                            <span className="badge rounded-pill bg-danger">{approvalPending}</span>
                                        ) : null}
                                    </Link>
                                </li>
                                <li hidden={!hasRoute("/dck/approvals")}>
                                    <Link to="/dck/approvals?status=approved" data-key="t-approvals-history">
                                        審核歷程
                                    </Link>
                                </li>
                            </ul>
                        </li>
                        ) : null}
                    </ul>
                </div>
            </SimpleBar>
        </React.Fragment>
    );
};
SidebarContent.propTypes = {
    // location: PropTypes.object,
    t: PropTypes.any,
};
// export default withRouter((SidebarContent));
export default SidebarContent;
